import React from 'react'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import useIntl from '@/utils/intl'
import { useRouter } from 'next/navigation'
import { resolveImageUrl } from '@/utils/constants'
import { useTheme } from '@/context/ThemeContext'

interface Props {
  onClose?: () => void
  status: string
}

const PendingInfo: React.FC<Props> = ({ onClose }) => {
  const { translate } = useIntl()
  const router = useRouter()
  const { theme } = useTheme()

  const exitWebview = (): void => {
    let webView
    if ((window as any).mobiBridge !== undefined) {
      webView = (window as any).mobiBridge
    }
    if ((window as any).ReactNativeWebview !== undefined) {
      webView = (window as any).ReactNativeWebview
    }
    if (webView !== undefined) {
      const data = { key: 'exit' }
      webView.postMessage(JSON.stringify(data))
    } else {
      router.push('/')
    }
  }

  return (
    <div className='"bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start relative no-scrollbar'>
      <div className='flex-grow px-4 py-4 sm:px-8 sm:py-8 overflow-auto no-scrollbar flex flex-col gap-4 items-center justify-center'>
        <div className='flex items-center justify-center'>
          <img
            src={resolveImageUrl(`/uploads/icons/${
                        theme === 'dark'
                          ? 'high_five_dark.svg'
                          : 'high_five_light.svg'
                      }`)} alt='success'
          />
        </div>
        <div className='px-6 sm:px-12'>
          <span className='text-textHigh font-extrabold text-lg text-center block'>
            {translate('leasing.pending.title')}
          </span>
          <span className='text-textMid text-sm text-center whitespace-pre-line block'>
            {translate('leasing.pending.description')}
          </span>
        </div>
      </div>

      <div className='sticky bottom-0 rounded-b-xl right-0 left-0 z-50 p-4 sm:p-6 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <div className='w-full max-w-[90vw] sm:max-w-md mx-auto flex gap-4'>
          <DarkButton fullwidth size='sm' onClick={exitWebview}>
            {translate('continue')}
          </DarkButton>
        </div>
      </div>
    </div>
  )
}

export default PendingInfo
